import React from 'react'
import { InfoTooltip } from '@wellbeingxltd/fe-lib/components'
import { ProductsList } from './Products'
import { ShopifyProducts } from './ShopifyProducts'

const columnsWithoutShopify = [
    {
        Header: 'Image',
        accessor: 'imageThumbS',
        width: 50,
        Cell: ({ row }) => <img className="resource-image" src={row.original.imageThumbS} alt="" />,
    },
    {
        Header: 'Title',
        accessor: 'title',
        Cell: ({ row }) => <span className="resource-title">{row.original.title}</span>,
    },
    { Header: 'Type', accessor: 'type', width: 50 },
    {
        Header: 'Products',
        accessor: 'productsV2',
        Cell: ({ row }) => <ProductsList row={row} />,
    },
    {
        Header: 'ResourceId',
        accessor: 'resourceId',
        Cell: ({ row }) => <span className="resource-wrap">{row.original.resourceId}</span>,
    },
]

const columnsWithShopify = [
    {
        Header: 'Image',
        accessor: 'imageThumbS',
        width: 100,
        Cell: ({ row }) => <img className="resource-image" src={row.original.imageThumbS} alt="" />,
    },
    {
        Header: 'Title',
        accessor: 'title',
        Cell: ({ row }) => <span className="resource-title">{row.original.title}</span>,
    },
    { Header: 'Type', accessor: 'type', width: 90 },
    {
        Header: 'Products',
        accessor: 'productsV2',
        width: 300,
        Cell: ({ row }) => <ProductsList row={row} />,
    },
    {
        Header: (
            <div>
                Link Shopify products <InfoTooltip module="linkShopifyProducts" />
            </div>
        ),
        accessor: 'shopifyProducts',
        width: 400,
        Cell: ({ row }) => <ShopifyProducts row={row} />,
    },
    {
        Header: 'ResourceId',
        accessor: 'resourceId',
        Cell: ({ row }) => <span className="resource-wrap">{row.original.resourceId}</span>,
    },
]

export const getColumnsData = shopifyProductsError => (shopifyProductsError ? columnsWithoutShopify : columnsWithShopify)
